import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'app/shared/components/alert/alert/alert.module';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputModule } from 'app/shared/components/input/input.module';
import { ModalModule } from 'app/shared/components/modal/modal/modal.module';
import { PaginatorModule } from 'app/shared/components/paginator/paginator.module';
import { PanelModule } from 'app/shared/components/panel/panel.module';
import { PopoverModule } from 'app/shared/components/popover/popover.module';
import { ProgressBarModule } from 'app/shared/components/progress-bar/progress-bar.module';
import { TabsModule } from 'app/shared/components/tabs/tabs.module';
import { TableModule } from 'app/shared/components/table/table.module';
import { CpfPipe } from 'app/shared/pipes/cpf.pipe';
import { PhonePipe } from 'app/shared/pipes/phone.pipe';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { NotAccreditedBadgeComponent } from './components/not-accredited-badge/not-accredited-badge.component';
import { PhysicianCardComponent } from './components/physician-card/physician-card.component';
import { PhysicianProcedureItemComponent } from './components/physician-procedure-item/physician-procedure-item.component';
import { UserCouponItemComponent } from './components/user-coupon-item/user-coupon-item.component';
import { UserCouponProcedureItemComponent } from './components/user-coupon-procedure-item/user-coupon-procedure-item.component';
import { CouponRoutingModule } from './coupon-routing.module';
import { CouponSearchUserComponent } from './pages/coupon-search-user/coupon-search-user.component';
import { ListPhysicianProceduresComponent } from './pages/list-physician-procedures/list-physician-procedures.component';
import { PhysicianDetailsComponent } from './pages/physician-details/physician-details.component';
import { PhysicianListComponent } from './pages/physician-list/physician-list.component';
import { PurchaseSummaryComponent } from './pages/purchase-summary/purchase-summary.component';
import { PurchaseHistoryComponent } from './pages/purchase-history/purchase-history.component';
import { PurchaseDetailsComponent } from './pages/purchase-details/purchase-details.component';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';

@NgModule({
  declarations: [
    CouponSearchUserComponent,
    PhysicianCardComponent,
    PhysicianListComponent,
    PhysicianDetailsComponent,
    ListPhysicianProceduresComponent,
    PhysicianProcedureItemComponent,
    UserCouponItemComponent,
    UserCouponProcedureItemComponent,
    PurchaseSummaryComponent,
    CalendarComponent,
    NotAccreditedBadgeComponent,
    AddressSelectorComponent,
    PurchaseHistoryComponent,
    PurchaseDetailsComponent,
  ],
  imports: [
    CommonModule,
    CouponRoutingModule,
    InputModule,
    ButtonModule,
    PanelModule,
    RadioButtonModule,
    ReactiveFormsModule,
    PaginatorModule,
    PhonePipe,
    CpfPipe,
    PanelModule,
    PaginatorModule,
    DialogModule,
    DatePickerModule,
    FormsModule,
    PopoverModule,
    AlertModule,
    ModalModule,
    TableModule,
    TabsModule,
    ProgressBarModule,
    TooltipModule,
  ],
})
export class CouponModule {}
